import { Box, Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const MaterialPropertiesLegend = () => {
  const { t } = useTenantTranslation();
  return (
    <Stack direction="row" gap={2} alignItems="center">
      {[
        { colour: "secondary.main", label: "differsFromDefault" },
        { colour: "error.main", label: "impossibleCombination" },
        { colour: "warning.main", label: "materialExcludedByLimit" },
      ].map(({ colour, label }) => (
        <Stack key={label} direction="row" gap={1} alignItems="center">
          <Box
            sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: colour }}
          />
          <Typography variant="caption">{t(label)}</Typography>
        </Stack>
      ))}
      <Typography variant="caption" sx={{ bgcolor: "warning.light", px: 1 }}>
        {t("edited")}
      </Typography>
    </Stack>
  );
};
